// frontend/app/models/schemas/thirdPartyRequestSchema.zod.ts
import {z} from 'zod';

import {PHONE_NUMBER_REGEX} from '../../utils/validation';

const REQUIRED_FIELD_MESSAGE = 'This is a required field';

export const ThirdPartyRequestSchema = z.object({
  firstName: z.string().min(1, REQUIRED_FIELD_MESSAGE),
  lastName: z.string().min(1, REQUIRED_FIELD_MESSAGE),
  email: z.string().min(1, REQUIRED_FIELD_MESSAGE).email('Please enter a valid email address'),
  phone: z
    .string()
    .min(1, REQUIRED_FIELD_MESSAGE)
    .regex(PHONE_NUMBER_REGEX, 'Please enter a valid Australian phone number'),
  reviewPersonName: z.string().min(1, REQUIRED_FIELD_MESSAGE),
  relationship: z.string().min(1, REQUIRED_FIELD_MESSAGE),
  description: z.string().min(1, REQUIRED_FIELD_MESSAGE),
});

export type ThirdPartyRequestData = z.infer<typeof ThirdPartyRequestSchema>;
